import React from "react";
import { Modal, Button, Input, Select } from "antd";

const { Option } = Select;

const MachineModal = ({
  isModalOpen,
  handleCloseModal,
  newDepartment,
  setNewDepartment,
  errors,
  handleSave,
  machines,
  isEditMode,
  users,
}) => {
  return (
    <Modal
      title={isEditMode ? "Departman Güncelle" : "Departman Ekle"}
      visible={isModalOpen}
      onCancel={handleCloseModal}
      footer={null}
    >
      <div className="grid grid-cols-2 gap-4">
        <Input
          placeholder="Departman Adı"
          value={newDepartment.name}
          onChange={(e) =>
            setNewDepartment({ ...newDepartment, name: e.target.value })
          }
        />
        {errors.name && <small className="text-red-500">{errors.name}</small>}
        <Input
          placeholder="Departman Kodu"
          value={newDepartment.code}
          onChange={(e) =>
            setNewDepartment({ ...newDepartment, code: e.target.value })
          }
        />
        {errors.name && <small className="text-red-500">{errors.code}</small>}
        <Input.TextArea
          placeholder="Açıklama"
          value={newDepartment.description}
          onChange={(e) =>
            setNewDepartment({
              ...newDepartment,
              description: e.target.value,
            })
          }
          rows={3}
        />
        <Input
          placeholder="Lokasyon"
          value={newDepartment.location}
          onChange={(e) =>
            setNewDepartment({ ...newDepartment, location: e.target.value })
          }
        />
        {errors.name && (
          <small className="text-red-500">{errors.location}</small>
        )}
        <Input
          placeholder="Çalışan Sayısı"
          type="number"
          value={newDepartment.employeeCount}
          onChange={(e) =>
            setNewDepartment({
              ...newDepartment,
              employeeCount: Number(e.target.value),
            })
          }
        />
        {errors.name && (
          <small className="text-red-500">{errors.employeeCount}</small>
        )}
        <Select
          placeholder="Durum"
          value={newDepartment.status}
          onChange={(value) =>
            setNewDepartment({ ...newDepartment, status: value })
          }
        >
          <Option value="Active">Aktif</Option>
          <Option value="Inactive">Pasif</Option>
        </Select>
        {errors.name && <small className="text-red-500">{errors.status}</small>}
        <Select
          value={newDepartment.manager}
          showSearch
          placeholder="Yönetici Seçiniz"
          optionFilterProp="label"
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={users.map((manager) => ({
            value: manager._id,
            label: manager.name,
          }))}
          onChange={(value) =>
            setNewDepartment({ ...newDepartment, manager: value })
          }
        />
        {errors.department && (
          <small className="text-red-500">{errors.manager}</small>
        )}
        <Select
          value={newDepartment.machines}
          mode="multiple"
          style={{
            width: "100%",
          }}
          placeholder="Departmana Ait Makineleri Seçiniz"
          onChange={(value) =>
            setNewDepartment({ ...newDepartment, machines: value })
          }
          options={machines.map((machine) => ({
            value: machine._id,
            label: machine.name,
          }))}
        />
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button
          onClick={handleCloseModal}
          className="bg-red-500 text-white hover:bg-red-600"
        >
          İptal
        </Button>
        <Button
          type="primary"
          onClick={handleSave}
          className="bg-black text-white hover:bg-gray-800"
        >
          {isEditMode ? "Güncelle" : "Ekle"}
        </Button>
      </div>
    </Modal>
  );
};

export default MachineModal;
